import React, { forwardRef } from 'react'
import QRCode from 'react-qr-code'

// Этикетки для наклейки на имущество: QR с инвентарным номером + название.
// По этому QR потом идёт инвентаризация с телефона (вкладка «Инвентаризация»).
const Labels = forwardRef(({ items }, ref) => {
	return (
		<div ref={ref} style={{ 'padding': '8mm' }}>
			<style>{`
				@page { size: A4; margin: 8mm; }
				.fa-labels { display: flex; flex-wrap: wrap; gap: 4mm; }
				.fa-label { width: 60mm; height: 32mm; border: 1px dashed #999; border-radius: 2mm;
					display: flex; align-items: center; gap: 3mm; padding: 2mm 3mm; box-sizing: border-box;
					page-break-inside: avoid; break-inside: avoid; font-family: Arial, sans-serif; }
				.fa-label-text { overflow: hidden; }
				.fa-label-number { font-size: 13px; font-weight: bold; }
				.fa-label-name { font-size: 10px; line-height: 1.2; max-height: 3.6em; overflow: hidden; }
				.fa-label-pos { font-size: 9px; color: #555; margin-top: 1mm; }
			`}</style>
			<div className="fa-labels">
				{items.map(item => (
					<div className="fa-label" key={item.id}>
						<QRCode value={item.inventory_number} size={88} />
						<div className="fa-label-text">
							<div className="fa-label-number">{item.inventory_number}</div>
							<div className="fa-label-name">{item.name}</div>
							<div className="fa-label-pos">{item.pos_name}</div>
						</div>
					</div>
				))}
			</div>
		</div>
	)
})

export default Labels
